import { render } from "./StaticPowderModelAdd.vue?vue&type=template&id=03475dd8&scoped=true"
import script from "./StaticPowderModelAdd.vue?vue&type=script&lang=js"
export * from "./StaticPowderModelAdd.vue?vue&type=script&lang=js"

import "./StaticPowderModelAdd.vue?vue&type=style&index=0&id=03475dd8&scoped=true&lang=css"
/* custom blocks */
import block0 from "./StaticPowderModelAdd.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03475dd8"]])

export default __exports__